import { render, staticRenderFns } from "./NotificationsPanelIcon.vue?vue&type=template&id=d3b6c166&"
import script from "./NotificationsPanelIcon.vue?vue&type=script&lang=js&"
export * from "./NotificationsPanelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports